(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linesheet-order-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-linesheet]');
  if (!root) return;

  var usdRate = parseFloat(root.dataset.usdRate) || 161;
  var eurRate = parseFloat(root.dataset.eurRate) || 184;
  var currency = root.dataset.currency || 'JPY';
  var inputs = Array.prototype.slice.call(root.querySelectorAll('input[data-vid]'));
  var cartQty = {};

  var moneyFmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: currency
  });
  /* Shopify Liquid/AJAX prices are in the smallest 1/100 unit for all currencies, JPY included */
  function money(cents) { return moneyFmt.format(cents / 100); }

  /* ---- retail price formatting ---- */
  root.querySelectorAll('[data-jpy]').forEach(function (el) {
    var raw = parseInt(el.dataset.jpy, 10);
    if (!raw) return;
    el.textContent = '\u00A5' + raw.toLocaleString('ja-JP');
    var row = el.parentElement;
    row.querySelector('[data-usd]').textContent = '$' + Math.round(raw / usdRate).toLocaleString('en-US') + '.00';
    row.querySelector('[data-eur]').textContent = '\u20AC' + Math.round(raw / eurRate).toLocaleString('en-US') + '.00';
  });

  /* ---- totals: row subtotals, per-product units & cost, grand totals ---- */
  function recalc() {
    root.querySelectorAll('.mx-row').forEach(function (row) {
      var t = row.querySelector('[data-total]');
      if (!t) return;
      var sum = 0;
      row.querySelectorAll('input').forEach(function (i) { sum += parseInt(i.value, 10) || 0; });
      t.textContent = sum || '';
    });
    var grandU = 0, grandC = 0;
    root.querySelectorAll('[data-product]').forEach(function (col) {
      var u = 0, c = 0;
      col.querySelectorAll('input').forEach(function (i) {
        var q = parseInt(i.value, 10) || 0;
        u += q;
        c += q * (parseInt(i.dataset.price, 10) || 0);
      });
      col.querySelector('[data-units]').textContent = u || '';
      col.querySelector('[data-cost]').textContent = c ? money(c) : '';
      grandU += u; grandC += c;
    });
    root.querySelector('[data-grand]').textContent = grandU;
    root.querySelector('[data-grand-cost]').textContent = money(grandC);
  }
  inputs.forEach(function (i) { i.addEventListener('input', recalc); });

  /* ---- prefill from cart ---- */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cart.items.forEach(function (item) { cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity; });
      inputs.forEach(function (i) {
        var q = cartQty[i.dataset.vid];
        if (q) i.value = q;
      });
      recalc();
    })
    .catch(function () { recalc(); });

  /* ---- save order draft ---- */
  var btn = root.querySelector('[data-save]');
  var toast = root.querySelector('[data-toast]');
  function say(msg, isErr) {
    toast.style.display = 'block';
    toast.classList.toggle('err', !!isErr);
    toast.textContent = msg;
  }

  btn.addEventListener('click', function () {
    var adds = [];
    var updates = {};
    inputs.forEach(function (i) {
      var vid = i.dataset.vid;
      var qty = parseInt(i.value, 10) || 0;
      var inCart = Object.prototype.hasOwnProperty.call(cartQty, vid);
      if (inCart && cartQty[vid] !== qty) {
        updates[vid] = qty;
      } else if (!inCart && qty > 0) {
        adds.push({ id: parseInt(vid, 10), quantity: qty });
      }
    });

    if (!adds.length && !Object.keys(updates).length) {
      say('Nothing to save \u2014 the sheet matches your cart.');
      return;
    }

    btn.disabled = true;
    var chain = Promise.resolve();

    if (adds.length) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: adds })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add items'); });
        });
      });
    }
    if (Object.keys(updates).length) {
      chain = chain.then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error('Could not update quantities');
        });
      });
    }

    chain
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        cartQty = {};
        cart.items.forEach(function (item) { cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity; });
        say('Order draft saved to cart \u2014 ' + cart.item_count + ' units total.');
        document.dispatchEvent(new CustomEvent('linesheet:cart-updated', { detail: cart }));
      })
      .catch(function (err) { say(err.message, true); })
      .finally(function () { btn.disabled = false; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
